module.exports = __webpack_public_path__ + "static/media/react.aad55f82.png";